import { staffSessionHeaders } from 'utils/auth';

const defaultHeaders = {
  // 'Content-Type': 'application/json',
};

export const createFetchConfig = (token?: string) => {
  const headers = { ...defaultHeaders };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
    Object.assign(headers, staffSessionHeaders());
  }
  return { headers };
};
